import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import WelcomeModal from "./components/WelcomeModal";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Vision from "./pages/Vision";
import EmotionalSafety from "./pages/EmotionalSafety";
import EducationalStaff from "./pages/EducationalStaff";
import HorizontalGroups from "./pages/HorizontalGroups";
import ParentCollaboration from "./pages/ParentCollaboration";
import IPadSystem from "./pages/IPadSystem";
import ReceivingPolicy from "./pages/ReceivingPolicy";
import Nutrition from "./pages/Nutrition";
import Activities from "./pages/Activities";
import SafetyHygiene from "./pages/SafetyHygiene";
import Services from "./pages/Services";
import DailyRoutine from "./pages/DailyRoutine";
import Contact from "./pages/Contact";
import RegisterForm from "./components/RegisterForm";
import FAQ from "./pages/FAQ";
import TransportationPolicy from "./pages/TransportationPolicy";
import OpeningClosingChecklist from "./pages/OpeningClosingChecklist";
import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <WelcomeModal />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/vision" element={<Vision />} />
              <Route path="/services" element={<Services />} />
              <Route path="/daily-routine" element={<DailyRoutine />} />
              {/* <Route path="/gallery" element={<Gallery />} /> */}
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/register" element={<RegisterForm />} />
              <Route path="/emotional-safety" element={<EmotionalSafety />} />
              <Route path="/educational-staff" element={<EducationalStaff />} />
              <Route path="/horizontal-groups" element={<HorizontalGroups />} />
              <Route
                path="/parent-collaboration"
                element={<ParentCollaboration />}
              />
              <Route path="/ipad-system" element={<IPadSystem />} />
              <Route path="/receiving-policy" element={<ReceivingPolicy />} />
              <Route
                path="/transportation-policy"
                element={<TransportationPolicy />}
              />
              <Route
                path="/opening-closing-checklist"
                element={<OpeningClosingChecklist />}
              />
              <Route path="/nutrition" element={<Nutrition />} />
              <Route path="/activities" element={<Activities />} />
              <Route path="/safety-hygiene" element={<SafetyHygiene />} />
            </Routes>
          </main>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
